import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import { Modal }from 'react-bootstrap';
import * as Actions from 'actions';
import {Link} from 'react-router';

class ViewUser extends React.Component {
	constructor(props) {
		super(props);

		this.cancel = this.cancel.bind(this);
		this.showEdit = this.showEdit.bind(this);
		this.handleLoginProxyAccount = this.handleLoginProxyAccount.bind(this);
	}

	cancel() {
		this.props.hideViewUser()
	}

	showEdit() {
		this.props.hideViewUser()
		this.props.beginEditUserSaga(this.props.users.tmp_user._id);
	}

	handleLoginProxyAccount() {
		this.props.beginInitProxyLogin(this.props.users.tmp_user)
	}

  render() {
  	let user = this.props.users.tmp_user;

  	if(this.props.users.tmp_user && this.props.users.viewing_user) {
	    const { address, name, phone, last_updated, _id, date_added, email, users_in_account, account_user_limit } = user;

	    const createdDate = moment(date_added);
	    const lastEdited = moment(last_updated);

	    const fullAddress =
	    	(address ? address.street : null) + '\n' +
	    	(address ? address.city : null) + '\n' + (address ? address.state : null) + '\n' +
	    	(address ? address.zip : null) + '\n' +
	    	(address ? address.country : null)

	    return (
	    	<Modal show={this.props.users.viewing_user} onHide={this.cancel} bsSize="sm">
		      <section className="panel">
		        <div className="panel-body">
		          <div className="thumb-info mb-md">
		            <div className="thumb-info-title">
		              <span className="thumb-info-inner">{name.first + ' ' + name.last}</span>
		            </div>
		          </div>
		          <h4 className="text-muted">Details</h4>
		          <hr className="dotted short" />
		          <ul className="list-unstyled">
		            <li><i className="fa fa-phone"></i> <span className="text-weight-bold">Phone: </span> {phone} </li>
		            <li><i className="fa fa-inbox"></i> <span className="text-weight-bold">Email: </span> {email} </li>
		            {(() => {
		            	if(address && address.street)
		            		return <li><i className="fa fa-home"></i> <span className="text-weight-bold">Address:</span> {address.street}</li>
		            })()}
		            <li>
		              <ul className="list-inline">
		              	{(() => {
		              		if(address && address.city)
		              			return <li><i className="fa fa-globe"></i> <span className="text-weight-bold">City: </span> {address.city} </li>
		              	})()}
		              	{(() => {
		              		if(address && address.state)
		              			return <li><span className="text-weight-bold">State: </span> {address.state}</li>
		              	})()}
		                {(() => {
		              		if(address && address.state)
		              			return <li><span className="text-weight-bold">Zip: </span> {address.zip}</li>
		              	})()}
		              </ul>
		            </li>
		            <li><i className="fa fa-calendar"></i> <strong>Created: </strong> { createdDate.fromNow()  } <small className="text-muted"> ({createdDate.format('YYYY-MM-DD')}) </small></li>
		            {(() => {
				        	if(user.role === 'Client Admin' && users_in_account !== undefined && account_user_limit !== undefined) {
				        		return (
				        			<li>
				        				<i className="fa fa-user-circle-o" />
				        				<span className="text-weight-bold"> Users In Account: </span>
				        				{`${users_in_account}/${account_user_limit}`}
				        			</li>
				        			)
				        	}
				        })()}
		          </ul>
		          <hr className="dotted short" />
		          <div className="clearfix">
		            <span className="text-uppercase text-muted pull-left">
		              <strong><i className="fa fa-history"></i> LAST UPDATED: </strong> { lastEdited.fromNow() } <small className="text-muted"> ({createdDate.format('YYYY-MM-DD')}) </small>
		            </span>
		          </div>
		        </div>
          	<div className='view-user-buttons row'>
		      		<div
		      			className='view-user-cancel-btn btn btn-default'
		      			onClick={this.cancel}>
		      			Close
		      		</div>
		      		{(() => {
		      			if(this.props.hasPermission('/Account Management/Users/Edit/User Details/'))
		      				return (
		      					<div
					      			className='view-user-edit-btn btn btn-primary'
					      			onClick={this.showEdit}>
					      			Edit
					      		</div>
		      				)
		      		})()}
		      		{(() => {
		      			if(this.props.users.user.is_admin) {
		      				return (
		      					<div
					      			className='log-in-proxy-account btn btn-primary'
					      			onClick={this.handleLoginProxyAccount}>
					      			Log In to User
					      		</div>
		      					)
		      			}
		      		})()}
	      		</div>
		      </section>
	      </Modal>
	    );
	  }
	  else
	  	return <div></div>
  }
}

export default connect(({users}) => ({users}), Actions)(ViewUser);



// WEBPACK FOOTER //
// ./src/browser/components/users/viewUser.js